import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import TextInput from '../../../widgets/components/Input/TextInput'
import { Formik } from 'formik'
import { SelectInput } from '../../../widgets/components/Input/SelectInput'

export default function EditIndividualLegalAndComplianceModal({ isActive, setIsActive, handleIsActive }: any) {
  const { formatMessage } = useIntl()
  const userSchema = {}

  const initialValues = {}

  const handleSubmit = (values: any) => {
    console.log(values)
  }
  return (
    <>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
        size='lg'
        fullscreen
      >
        <Modal.Header closeButton>
          <h2>{formatMessage({ id: 'Edit Profile Details' })}</h2>
        </Modal.Header>
        <Modal.Body className='container'>
          <div className='w-100 '>
            <Formik
              initialValues={initialValues}
              validationSchema={userSchema}
              onSubmit={handleSubmit}
            >
              {(formik) => (
                <Form>
                  <div className='row'>
                    <div className='col-md-6 col-12'>
                      <SelectInput
                        label={formatMessage({ id: 'Gender' })}
                        fieldName='Gender'
                        placeholder={formatMessage({
                          id: 'Select Gender',
                        })}
                        formik={formik}
                        toolTipText={formatMessage({
                          id: 'Select your gender',
                        })}
                        options={[]}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <TextInput
                        fieldType='text'
                        label={formatMessage({ id: 'Address' })}
                        fieldName='Address'
                        formik={formik}
                        placeholder={formatMessage({ id: 'Enter Full Address' })}
                        toolTipText={formatMessage({
                          id: 'Update the correspondence address of the Board Member here.',
                        })}
                        isStarRequired={true}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <SelectInput
                        label={formatMessage({ id: 'Govt. issued ID type' })}
                        fieldName='GovtID'
                        placeholder={formatMessage({
                          id: 'Select Govt. issued ID type',
                        })}
                        formik={formik}
                        toolTipText={formatMessage({
                          id: 'Select the updated Govt. issued ID type for the Board Member.',
                        })}
                        options={[]}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <TextInput
                        fieldType='text'
                        label={formatMessage({ id: 'Education' })}
                        fieldName='Education'
                        formik={formik}
                        placeholder={formatMessage({ id: 'Enter Education' })}
                        toolTipText={formatMessage({
                          id: 'Enter Education',
                        })}
                        isStarRequired={true}
                        isTooltipForModal={true}
                      />
                    </div>
                    <div className='col-md-6 col-12'>
                      <TextInput
                        fieldType='text'
                        label={formatMessage({ id: 'Govt. Issued ID Number' })}
                        fieldName='GovtIDNumber'
                        formik={formik}
                        placeholder={formatMessage({ id: 'Enter Govt. Issued ID Number' })}
                        toolTipText={formatMessage({
                          id: 'Update the selected Govt. issued ID  number here.',
                        })}
                        isStarRequired={true}
                        isTooltipForModal={true}
                      />
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Modal.Body>
        <Modal.Footer className='p-md-0 px-0 d-flex gap-2 gap-md-1 container'>
          <div className='d-flex gap-3 mx-md-0 mx-6 my-md-4 mx-0 my-0 mb-2 justify-content-md-end justify-content-center w-md-auto w-100 order-2 order-md-1'>
            <button
              className='btn bg-light custom-button-property text-muted font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
              style={{ padding: '15px 40px' }}
            >
              <span className='indicator-label font-size-13 p-0'>
                {formatMessage({ id: 'Cancel' })}
              </span>
            </button>
          </div>
          <div className='d-flex gap-3 mx-md-0 mx-6 my-md-4  mx-0 my-0 justify-content-md-end justify-content-center w-md-auto w-100 order-1 order-md-2'>
            <button
              className='btn bg-primary custom-button-property text-white font-size-13 me-md-2 me-0 fw-normal w-100 w-md-auto'
              style={{ padding: '15px 40px' }}
            >
              <span className='indicator-label font-size-13 p-0'>
                {formatMessage({ id: 'Save' })}
              </span>
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}
